import React from "react";
import YouTube from "react-youtube";

function YoutubeVideoPlayer(props) {
  const { videoId } = props;
  const opts = {
    width: "800",
    height: "500",
    playerVars: {
      autoplay: 1,
      modestbranding: 1,
      iv_load_policy: 3,
    },
  };

  const onReady = (event) => {
    event.target.pauseVideo();
  };

  return (
  <div className="youtube-container">
    <YouTube videoId={videoId} opts={opts} onReady={onReady} />
  </div>);
}

export default YoutubeVideoPlayer;
